import React from 'react';
import { Route, Routes } from 'react-router-dom';

import BurnCenterAdd from 'components/forms/BurnCenterAdd';
import useUser from 'hooks/useUser';
import BurnCentersList from './BurnCentersList';
import BurnCenterDetails from './details';

const BurnCenters: React.FC = () => {
  const { isAbaAdmin, isBcAdmin } = useUser();

  return (
    <Routes>
      <Route path="/" element={<BurnCentersList />} />
      {!isAbaAdmin && !isBcAdmin && <Route path="new" element={<BurnCenterAdd />} />}
      <Route path=":id/*" element={<BurnCenterDetails />} />
    </Routes>
  );
};

export default BurnCenters;
